<template>
  <div>
    <div id="snackbar">{{snackbar.text}}</div>
    <modal class="lot-modal" :show.sync="matchModal" body-classes="p-0" modal-classes="modal-dialog-centered">
      <card type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-4 py-lg-5" class="border-0">
        <div class="row">
          <div class="col-12 col-md">
            <div v-if="selectedLot">
              <div class="row">
                <div class="col text-center" style="max-height: 200px">
                  <img class="mw-100 h-100" :alt="`Vista satelital del Lote de ${selectedLot.area}ha`" :src="selectedLot.images[0] || defaultImage" style="border-radius: 1rem 1rem 0 0;"/>
                </div>
              </div>
              <div class="container h-100">
                <div class="row justify-content-center">
                  <div class="col col-sm-6 px-0">
                    <p class="pt-2 mb-0 text-center" style="color:black; font-size: 1.25rem !important;"><b>Lote de {{ selectedLot.area }}ha</b></p>
                  </div>
                </div>
                <p class="text-center mb-0">
                  A {{getDistanceFromSearchedCity(selectedLot)}}km. de la ciudad buscada
                </p>
                <div class="row px-3 justify-content-center">
                  <p class="mb-0 text-center">En {{ selectedLot.nearest_city }}</p>
                </div>
                <div class="row mt-3">
                  <div class="col text-left">
                    <p class="mb-0 pl-2"><b>Servicios</b></p>
                    <ul class="pl-2 pt-0" style="max-height: 130px; overflow-y: auto;">
                      <li v-for="(service, index) in selectedLot.services" :key="index" style="list-style-type: none">
                        ✓ {{ service }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="row px-3">
                  <b class="mb-0 text-left pl-2">Descripción</b>
                  <p class="mb-0 text-left pl-2" v-html="selectedLot.description.replace(/\n/g, '<br>')" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm">
            <div id="match-card"></div>
          </div>
        </div>
      </card>
    </modal>
    <div style="position: absolute; top: 0; left: 0; width: 100%; height: 300px; overflow: hidden;">
      <picture>
        <source :srcset="require('../assets/images/home-1080.webp')" media="(min-width: 721px)" />
        <source :srcset="require('../assets/images/home-720.webp')" media="(min-width: 413px)" />
        <img :src="require('../assets/images/home-412.webp')" style="width: 100%;" alt="Paisaje agrícola" />
      </picture>
    </div>
    <section class="section section-lg pt-0 mt-5 mt-md-12 pb-5" style="padding-top: 85px !important;">
      <div class="container" style="max-width: 100%">
        <div class="row row-grid justify-content-center">
          <div class="col-9">
            <card class="border-0" shadow body-classes="pt-5">
              <div class="row justify-content-center mx-0">
                <div class="col-12 col-lg-3 text-center mb-3 px-1">
                  <base-dropdown class="w-100 purpose-dropdown" tag="li">
                    <base-input class="purpose-selector" slot="title" data-toggle="dropdown" role="button" placeholder="Qué vas a producir?" v-model="aptitudesChecked.aptitudes" />
                    <div v-for="(aptitude, index) in aptitudes" :key="index">
                      <div style="display: flex; justify-content: space-between;">
                        <dropdown-with-checkbox :indeterminate="aptitude.indeterminate" :checked="aptitude.checked" :onClick="() => onAptitudeClick(aptitude.label)" :label="aptitude.label"/>
                        <icon v-if="aptitude.hasDetails" :name="`fa fa-caret-${aptitude.showDetails ? 'up' : 'down'}`" size="sm" :onClick="() => togleShowDetails(aptitude.label)"/>
                      </div>
                      <div v-if="aptitude.showDetails">
                        <div v-for="(detail, detailIndex) in aptitude.details" :key="detailIndex">
                          <dropdown-with-checkbox :checked="detail.checked" :onClick="() => onDetailClick(aptitude.label, detail.label)" :label="detail.label" :identation="2"/>
                        </div>
                      </div>
                    </div>
                  </base-dropdown>
                </div>
                <div class="col-12 col-lg-5 text-center px-1">
                  <PlacesInput placeholder="Dónde?" leftIcon="fa fa-location-arrow" v-model="city" @placeChanged="getAddressData"/>
                </div>
                <div class="col-12 col-lg-2 text-center align-items-end px-1">
                  <base-input type="number" placeholder="Superficie (Ha)" v-model="area" @wheel.prevent>
                  </base-input>
                </div>
                <div class="col-lg-2 text-center align-items-center px-1">
                  <base-button block type="secondary" @click="searchLot(true)" style="background-color: #4E9306; color: white; border-width: 0px">Buscar</base-button>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
    <div v-show="badScoreForm" class="container pt-0 pb-5" style="max-width: 100%">
      <div class="row row-grid justify-content-center">
        <div class="col-10">
          <card class="border-0" shadow>
            <div id="bad-score-form" />
          </card>
        </div>
      </div>
    </div>
    <section v-if="lots.length" class="section section-lg pt-0 pb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-6 col-lg-4 px-3 py-3" v-for="(lot, index) in lots" :key="index" style="max-width: 385px; cursor:pointer" @click="openMatch(lot)">
            <card class="lot-card border-0" hover shadow body-classes="p-0">
              <div class="row">
                <div class="col text-center" style="max-height: 200px;">
                  <img class="mw-100 h-100" :alt="`Vista satelital del Lote de ${lot.area}ha`" :src="lot.images[0] || defaultImage" style="border-radius: 1rem 1rem 0 0;" />
                </div>
              </div>
              <div class="container h-100">
                <div class="row justify-content-center">
                  <div class="col px-0">
                    <p class="pt-2 mb-0 text-center one-line-text" style="color:black; font-size: 1.25rem !important;">
                      <b>Lote de {{ lot.area }}ha</b>
                    </p>
                  </div>
                </div>
                <p class="text-center mb-0 one-line-text">
                  A {{getDistanceFromSearchedCity(lot)}}km. de la ciudad buscada
                </p>
                <div class="row px-3 justify-content-center">
                  <p class="mb-0 text-center one-line-text">En {{ lot.nearest_city }}</p>
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <p class="mb-1 pl-2"><b>Puntaje:</b> {{ parseFloat(lot.score) }}/10</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p class="mb-1 pl-2 description-text"><b>Descripción: </b> {{ lot.description }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p class="mb-1 pl-2"><b>Precio: </b> {{ lot.value_unit == 'Otro' || !lot.value_unit ? '-' : `${parseFloat(lot.value)} ${lot.value_unit}`}}</p>
                  </div>
                </div>
                <div class="row" style="position: absolute; bottom: 20px; left: 0; right: 0;">
                  <div class="col-12 col-md text-center align-self-end">
                    <base-button class="lot-action-btn" type="secondary" style="border-width: 0px">Lo quiero</base-button>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
    <section v-if="loadingSearch" class="section section-lg py-5" style="text-align: -webkit-center;">
      <div class="loader" />
    </section>
    <section v-if="(lots.length || lotsUnderScore.length) && this.nextPage <= this.lastPage" class="section section-lg pb-5 pt-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-6 col-md-4">
            <base-button block type="secondary" style="background-color: #4E9306; color: white; border-width: 0px" @click="showMoreLots()">Mostrar otros lotes</base-button>
          </div>
        </div>
      </div>
    </section>
    <template v-if="showReviews">
      <section class="section section-lg pb-5 pt-0 mx-5">
        <div class="container">
          <div class="row justify-content-center">
            <h1 class="text-center" style="color: #404040; font-size: 32px;">
              Descubre la forma más fácil de <span style="color: #4e9306">alquilar</span> lotes
            </h1>
          </div>
          <div class="row justify-content-center mt-4">
            <h2 class="text-center" style="color: #404040; font-size: 20px;">
              La primera plataforma inteligente que permitirá encontrar el campo que estas buscando para tu producción
            </h2>
          </div>
        </div>
      </section>
      <section class="section section-lg pb-5 pt-0 mx-5">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-3 px-3 py-3" v-for="(review, index) in reviews" :key="index">
            <card shadow class="card-profile" hover no-body style="height: 470px;">
              <div class="full-width" :style="`position: absolute; width: 100%; height: 6rem; background-color: ${review.color}`"></div>
              <div class="px-4">
                <div class="row justify-content-center">
                  <div class="card-profile-image text-center pt-3" style="max-height: 200px; z-index: 1;">
                    <img :src="review.img" :alt="`Opinión de ${review.name}`" class="rounded-circle mw-100 h-100">
                  </div>
                </div>
                <div class="text-center mt-3">
                  <h3 class="mb-0" style="color: #545454">{{review.name}}</h3>
                  <div class="h6 font-weight-300" style="color: #545454">{{review.role}}</div>
                </div>
                <div class="py-3 text-center">
                  <div class="row justify-content-center">
                    <div class="col">
                      <p style="color: #545454"><i>{{review.review}}</i></p>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import Modal from '../components/Modal'
import BaseDropdown from "@/components/BaseDropdown"
import CloseButton from "@/components/CloseButton"
import DropdownWithCheckbox from "@/components/DropdownWithCheckbox"
import Icon from "@/components/Icon"
import PlacesInput from '@/components/PlacesInput'
import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'
import _result from 'lodash/result'
import _sortBy from 'lodash/sortBy'
import _max from 'lodash/max'
import _toLower from 'lodash/toLower'
import _remove from 'lodash/remove'
import mixpanel from "mixpanel-browser"


export default {
  name: "search",
  components: {
    flatPicker,
    Modal,
    CloseButton,
    BaseDropdown,
    DropdownWithCheckbox,
    Icon,
    PlacesInput
  },
  data() {
    return {
      city: '',
      cityData: null,
      area: '',
      lots: [],
      lotsUnderScore: [],
      allLots: [],
      selectedLot: null,
      lotsFetched: false,
      nextPage: 1,
      lastPage: null,
      matchModal: false,
      aptitudes: {},
      loadingSearch: false,
      showReviews: true,
      snackbar: {
        text: '',
        color: ''
      },
      reviews: [
        {
          name: 'Juan',
          role: 'Productor agrícola',
          review: 'No se dimensiona la cantidad de tiempo y recursos que se pierden en buscar buenos lotes.',
          img: require('../assets/images/profile-juan.webp'),
          color: '#4E9306'
        },
        {
          name: 'Ana',
          role: 'Productora agrícola',
          review: 'El mejor rinde histórico de la empresa se dio en un lote conseguido por la plataforma.',
          img: require('../assets/images/profile-ana.webp'),
          color: '#E5A20A'
        },
        {
          name: 'Ignacio',
          role: 'Productor agrícola',
          review: 'Conseguimos lotes hasta un 15% más baratos de lo que generalmente alquilamos.',
          img: require('../assets/images/profile-ignacio.webp'),
          color: '#4E9306'
        },
        {
          name: 'Agustín',
          role: 'Productor ganadero',
          review: 'La mayoría de las plataformas venden campos. Alquilar baja el riesgo de poner en marcha un negocio.',
          img: require('../assets/images/profile-agustin.webp'),
          color: '#E5A20A'
        }
      ],
      badScoreForm: false,
      MAX_BAD_SCORE: parseFloat(process.env.VUE_APP_MAX_BAD_SCORE),
      defaultImage: require('../assets/images/default-satellite-image.webp')
    }
  },
  computed: {
    maxScore () {
      return _max(this.allLots.map(lot => parseFloat(lot.score)))
    },
    aptitudesChecked () {
      const aptitudes = []
      const details = []
      Object.values(this.aptitudes).forEach(aptitude => {
        if (aptitude.checked) {
          aptitudes.push(aptitude.label)
          Object.values(aptitude.details).forEach(detail => {
            if (detail.checked) details.push(detail.label)
          })
        }
      })

      return { aptitudes, details }
    }
  },
  async mounted() {
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'pageview',
        'page_location': '/',
        'page_title': 'Search'
    });

    await this.getAptitudes()

    window.addEventListener('message', event => {
      if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
        this.onConversionFormSubmit()
      }
    })
  },
  methods: {
    getAddressData (placeResultData) {
      this.cityData = placeResultData;
    },
    async getAptitudes () {
      try {
        const {aptitudes} = await (await fetch(`${process.env.VUE_APP_API_URL}/aptitude`)).json()

        const _aptitudes = {}

        aptitudes.forEach(({description, unique, detail}) => {
          const details = {}
          detail.forEach(label => {
            details[label] = {
              label,
              checked: false
            }
          })
          _aptitudes[description] = {
            label: description,
            checked: false,
            indeterminate: false,
            unique,
            hasDetails: Object.keys(details).length > 0,
            showDetails: true,
            details
          }
        })

        this.aptitudes = _aptitudes
      } catch (e) {
        console.log('Error:', e)
        this.snackbar.text = 'Error obteniendo las aptitudes. Por favor, recargue la página'
        this.snackbar.color = 'error'
        this.showSnackbar()
      }
    },
    toggleAptitude (aptitude, checked) {
      aptitude.checked = checked
      aptitude.indeterminate = checked
      Object.values(aptitude.details).forEach(detail => {
        detail.checked = checked
      })
    },
    onAptitudeClick (_aptitude) {
      const { [_aptitude]: aptitude, ...othersAptitudes } = this.aptitudes;
      Object.values(aptitude.details).forEach(detail => {
        detail.checked = aptitude.indeterminate ? false : !aptitude.checked
      })

      if(aptitude.unique && !aptitude.checked) {
        Object.values(othersAptitudes).forEach(otherAptitude => {
          this.toggleAptitude(otherAptitude, false)
        })
      } else if (!aptitude.checked) {
        Object.values(othersAptitudes).forEach(otherAptitude => {
          if (otherAptitude.unique) {
            this.toggleAptitude(otherAptitude, false)
          }
        })
      }

      this.aptitudes = {
        ...this.aptitudes,
        [_aptitude]: {
          ...aptitude,
          checked: !aptitude.checked,
          indeterminate: false,
          details: aptitude.details
        }
      }
    },
    onDetailClick (_aptitude, _detail) {
      const { [_aptitude]: aptitude, ...othersAptitudes } = this.aptitudes
      aptitude.details[_detail].checked = !aptitude.details[_detail].checked
      const detailsList = Object.values(aptitude.details)
      let checkedDetailsCount = 0
      detailsList.forEach((detail) => {
        if (detail.checked) checkedDetailsCount += 1
      })
      if (checkedDetailsCount === detailsList.length) {
        aptitude.checked = true
        aptitude.indeterminate = false
      } else if (checkedDetailsCount === 0) {
        aptitude.checked = false
        aptitude.indeterminate = false
      } else {
        aptitude.checked = true
        aptitude.indeterminate = true
      }

      Object.values(othersAptitudes).forEach(otherAptitude => {
        if (otherAptitude.unique) {
          this.toggleAptitude(otherAptitude, false)
        }
      })

      this.aptitudes = {
        ...this.aptitudes,
        [_aptitude]: {
          ...aptitude
        }
      }
    },
    togleShowDetails (aptitude) {
      this.aptitudes = {
        ...this.aptitudes,
        [aptitude]: {
          ...this.aptitudes[aptitude],
          showDetails: !this.aptitudes[aptitude].showDetails
        }
      }
    },
    async searchLot (newSearch = false) {
      if (newSearch) {
        mixpanel.track('Search lot', {
          city: _get(this, 'cityData.formatted_address', ''),
          aptitudes: !_isEmpty(this.aptitudesChecked.aptitudes) ? this.aptitudesChecked.aptitudes.join('-') : '',
          aptitudesDetails: !_isEmpty(this.aptitudesChecked.details) ? this.aptitudesChecked.details.join('-') : '',
          area: this.area || ''
        })
      }
      const MIN_AREA = 20
      const MAX_AREA = 10000
      let error = true

      if (!_get(this, 'cityData.formatted_address') || _isEmpty(this.aptitudesChecked.aptitudes) || _isEmpty(this.area)) {
        this.snackbar.text = 'Por favor, complete todos los campos.'
      } else if (!parseFloat(this.area)) {
        this.snackbar.text = `La superficie debe ser un número válido`
      } else if (!_isEmpty(this.area) && this.area <= MIN_AREA) {
        this.snackbar.text = `La superficie no debe ser menor o igual a ${MIN_AREA}ha.`
      } else if (!_isEmpty(this.area) && this.area >= MAX_AREA) {
        this.snackbar.text = `La superficie no debe ser mayor o igual a ${MAX_AREA}ha.`
      } else {
        error = false
      }

      if (error) {
        this.snackbar.color = 'error'
        this.showSnackbar()
        this.badScoreForm = false
        return
      }

      try {
        if (newSearch) this.nextPage = 1
        this.showReviews = false
        this.loadingSearch = true
        const headers = new Headers()
        headers.append("Content-Type", "application/json")
        const location = _get(this, 'cityData.geometry.location')
        const body = JSON.stringify({
          aptitude: this.aptitudesChecked.aptitudes[0],
          coordinates: {
            lat: location ? location.lat() : null,
            lng: location ? location.lng() : null,
          },
          area: this.area
        })
        const query = {
          limit: 12,
          page: this.nextPage
        }
        var requestOptions = {
          method: 'POST',
          headers,
          body
        }

        const response = await fetch(`${process.env.VUE_APP_API_URL}/lot?` + new URLSearchParams(query), requestOptions)
        let result = await response.json()
        if (response.status == 200) {
          this.allLots = newSearch ? result.lots : this.allLots.concat(result.lots)

          if (newSearch) this.lotsUnderScore = _remove(result.lots, (lot) => parseFloat(lot.score) < this.MAX_BAD_SCORE)

          this.lots = newSearch ? result.lots : this.lots.concat(result.lots)
          this.lastPage = result.pages
          if (newSearch && !this.lots.length) {
            this.openBadScoreForm()
          } else if (this.maxScore > this.MAX_BAD_SCORE && this.badScoreForm) {
            this.badScoreForm = false
          }
        } else {
          throw new Error(response.status)
        }
      } catch (e) {
        console.log(e)
        this.snackbar.text = 'Ha ocurrido un error, por favor inténtelo nuevamente.'
        this.snackbar.color = 'error'
        this.showSnackbar()
        this.badScoreForm = false
      } finally {
        this.lotsFetched = true
        this.nextPage = this.nextPage + 1
        this.loadingSearch = false
      }
    },
    openMatch (lot) {
      const lat = _result(this.cityData, 'geometry.location.lat', '')
      const lon = _result(this.cityData, 'geometry.location.lng', '')

      let matchForm = document.createElement('script')
      const info = `//BUSQUEDA// Ciudad: ${this.cityData.formatted_address} lat: ${lat} lon: ${lon} / Propósito: ${this.aptitudesChecked.aptitudes.toString()} / Superficie: ${this.area} / Puntaje máximo: ${this.maxScore} //ANUNCIO// ID: ${lot.id} / Título: ${lot.title} / Ciudad: ${lot.nearest_city} / Servicios: ${lot.services} / Detalle: ${this.aptitudesChecked.details.toString()} / Puntaje: ${lot.score}`

      matchForm.textContent = `
      hbspt.forms.create({
        region: "na1",
        portalId: "5093095",
        formId: "38a9150c-eebb-4812-ba10-2f25e6b20db5",
        onFormReady: function(form) {
          const inputs = form.elements;
          const message = inputs["message"];
          message.value = '${info}'
        }
      })`
      const matchCard = document.getElementById('match-card')
      matchCard.textContent = ''
      matchCard.appendChild(matchForm)

      this.selectedLot = lot
      this.matchModal = true
    },
    showSnackbar () {
      let x = document.getElementById("snackbar")
      x.className = `${this.snackbar.color} show`
      setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000)
    },
    openBadScoreForm () {
      this.badScoreForm = true
      let badScoreForm = document.createElement('script')

      const lat = _result(this.cityData, 'geometry.location.lat', '')
      const lon = _result(this.cityData, 'geometry.location.lng', '')

      const info = `//BUSQUEDA// Ciudad: ${this.cityData.formatted_address} lat: ${lat} lon: ${lon} / Propósito: ${this.aptitudesChecked.aptitudes.toString()} / Detalles: ${this.aptitudesChecked.details.toString()} / Superficie: ${this.area} / Puntuacion máxima: ${this.maxScore}`
      badScoreForm.textContent = `
      hbspt.forms.create({
        region: 'na1',
        portalId: '5093095',
        formId: '0c7eabda-d5e7-4b94-9b48-d94f677b09b1',
        onFormReady: function(form) {
          const inputs = form.elements;
          const message = inputs["message"];
          message.value = '${info}'
        }
      })`
      document.getElementById('bad-score-form').replaceChildren(badScoreForm)
    },
    getDistanceFromSearchedCity (lot) {
      return parseFloat(lot.distance).toFixed()
    },
    showMoreLots () {
      mixpanel.track('Show more lots')
      if (this.lotsUnderScore.length) {
        this.lots = this.lots.concat(this.lotsUnderScore)
        this.lotsUnderScore = []
      } else {
        this.searchLot()
      }
    },
    onConversionFormSubmit () {
      mixpanel.track('Form search conversion', {
        lotTitle: this.selectedLot.title,
        lotTitle: this.selectedLot.title,
        lotNearestCity: this.selectedLot.nearest_city,
        lotArea: this.selectedLot.area,
        lotValue: this.selectedLot.value,
        lotValueUnit: this.selectedLot.value_unit,
        city: _get(this, 'cityData.formatted_address', ''),
        aptitudes: !_isEmpty(this.aptitudesChecked.aptitudes) ? this.aptitudesChecked.aptitudes.join('-') : '',
        aptitudesDetails: !_isEmpty(this.aptitudesChecked.details) ? this.aptitudesChecked.details.join('-') : '',
        area: this.area || ''
      })
    }
  }
};
</script>
<style>
/* Hide the spinners on Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Hide the spinners on Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>